<template>
    <div
        v-if="options.showToast"
        class="guide-box"
        :style="'background-color: rgba(0, 0, 0,' + options.opacity + ')'">
        <div style=""></div>
    </div>
</template>

<script setup>
import { Spin, Icon, Progress } from "view-ui-plus";
import {
    ref,
    watch,
    getCurrentInstance,
    createApp,
    onMounted,
    nextTick,
} from "vue";

import Yustep1 from "@/components/Yu-step1.vue";
import Yustep2 from "@/components/Yu-step2.vue";
import Yustep3 from "@/components/Yu-step3.vue";

const app1 = createApp(Yustep1);
const container1 = document.createElement("div");
container1.setAttribute("class", "guideRef-tip");
app1.mount(container1);

const app2 = createApp(Yustep2);
const container2 = document.createElement("div");
container2.setAttribute("class", "guideRef-tip2");
app2.mount(container2);

const app3 = createApp(Yustep3);
const container3 = document.createElement("div");
container3.setAttribute("class", "guideRef-tip3");
app3.mount(container3);

const opt = defineProps({
    options: {
        type: Object,
        default: {},
    },
});

watch(
    () => opt.options.targetElement,
    (newValue, oldValue) => {
        let elem = "";
        if (Array.isArray(newValue)) {
            elem = newValue[0];
        } else {
            elem = newValue;
        }
        console.log(opt.options.targetElement);
        console.log(elem);
        console.log("opt.targetElement");
        // newValue.insertAdjacentElement('afterend', container);
        if (elem.contains(container1)) {
            elem.removeChild(container1);
        }
        if (elem.contains(container2)) {
            elem.removeChild(container2);
        }
        if (elem.contains(container3)) {
            elem.removeChild(container3);
        }

        switch (opt.options.type) {
            case "step1":
                elem.appendChild(container1);
                break;
            case "step2":
                elem.appendChild(container2);
                break;
            case "step3":
                elem.appendChild(container3);
                break;
            default:
                break;
        }
    }
);
</script>

<style lang="less"></style>
<style lang="less" scoped>
.loading {
    position: absolute;
    left: 50%;
    top: 48%;
    transform: translate(-50%, -50%);
}
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
    transform-origin: center;
}

.guide-box {
    height: 100vh;
    width: 100vw;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
}
.img {
    width: 172px;
    height: 36px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}

.img1 {
    width: 254px;
    height: 151px;
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
}
.pro-div {
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 15px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 1px 2px;
}
.load-txt {
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    margin-top: 30px;
}

.footer-box {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    .m-title {
        font-size: 16px;
        color: rgba(61, 61, 61, 1);
        font-weight: 500;
    }
    .s-title {
        font-size: 14px;
        color: rgba(61, 61, 61, 0.5);
        font-weight: 400;
    }
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
